import { CheckBoxWrapper, CustomInput, DatePickerGroup, DateRadioGroup, DayCheckbox, DayCheckboxGroup, ExpandableSection, HorizontalBox, IconWarn, InputLabel, InputLabel1, Label, Label1, NumberInput, NumberInputWrapper, RadioGroup, RadioInputGroup, RadioWrapper, RepeatSchedule, TextCreation } from "../../../main/AddBag/AddBag.styled";
import DatePicker from 'react-datepicker';
import { format, subDays } from 'date-fns';
import { uk } from 'date-fns/locale';
import { dayClassName, formatDate } from "../../../../utils/function";
import ImageAnimation2 from "../../../layout/loader/ImageAnimation2";

import 'react-datepicker/dist/react-datepicker.css';
import './CustomDatePickerModalrepeat.css';
import { useState } from "react";
const RepeatUpdate = ({ setIsAutomation, isAutomation, setArrayErrors, setStopAfter,
  repeatSchedule, setRepeatSchedule, selectDaily,
  setSelectDaily, selectedDays, setSelectedDays,
  dayOfMonth, setDayOfMonth, startDate,
  setStartDate, stopDate, setStopDate,
  stopCondition, setStopCondition, stopAfter, isLoading1, calculatedStart }) => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [isCalendar2Open, setIsCalendar2Open] = useState(false);
  console.log('startDate :>> ', startDate);
  console.log('stopDate :>> ', stopDate);
  const dayClassName1 = (date) => {
    const dateObj = new Date(date);
    const startDateObj = new Date(startDate);
    if (dateObj < subDays(startDateObj, 1)) {
      return "react-datepicker__day--min-date";
    }
    return null;
  };

  const handleDaysChange = (index) => {
    setSelectedDays((prev) => {
      if (prev.includes(index)) {
        return prev.filter((day) => day !== index);
      } else {
        return [...prev, index];
      }
    });
  };


  const handleDayOfMonthChange = (e) => {
    let value = parseInt(e.target.value, 10);

    // Перевіряємо, щоб значення було в межах 1 - 31
    if (value < 1) {
      value = 1;
    } else if (value > 31) {
      value = 31;
    }

    setDayOfMonth(value);
  };

  const handleNumberChange = (e) => {
    let value = parseInt(e.target.value, 10);
    if (value < 1) {
      value = 1;
    }
    setStopAfter(value);
    setStopCondition('after');
  };

  return (
    <>
      <HorizontalBox style={{ gap: "32px", width: '100%' }}>
        <Label style={{ width: 'calc(100% / 2 )' }}>Автоматизація</Label>
        <HorizontalBox >
          <CheckBoxWrapper>
            <input type="checkbox" id="automation" checked={isAutomation} onChange={() => {
              setIsAutomation(!isAutomation); setArrayErrors(prevErrors => ({
                ...prevErrors,
                timeErr: false,
              }));
            }} />
            <label htmlFor="automation" className="checkmark"></label>
          </CheckBoxWrapper>
          <Label1 htmlFor="automation">Зробити кошик регулярним</Label1>
        </HorizontalBox>
      </HorizontalBox>
      {isAutomation && (
        <ExpandableSection  >
          <RepeatSchedule  >
            <RadioGroup style={{ width: 'calc(100% / 2)' }}>
              <InputLabel htmlFor="repeatDaily">Повторювати за розкладом:</InputLabel>
              <RadioInputGroup>
                <RadioWrapper>
                  <input
                    type="radio"
                    id="repeatDaily"
                    name="repeatSchedule"
                    value='daily'
                    checked={repeatSchedule === 'daily'}
                    onChange={(e) => setRepeatSchedule(e.target.value)}
                  />
                  <label htmlFor='repeatDaily' className="radioMark"></label>
                </RadioWrapper>
                Щоденно
              </RadioInputGroup>
              <RadioInputGroup>
                <RadioWrapper>
                  <input
                    type="radio"
                    id="repeatWeekly"
                    name="repeatSchedule"
                    value='weekly'
                    checked={repeatSchedule === 'weekly'}
                    onChange={(e) => setRepeatSchedule(e.target.value)}
                  />
                  <label htmlFor='repeatWeekly' className="radioMark"></label>
                </RadioWrapper>
                Щотижнево
              </RadioInputGroup>
              <RadioInputGroup>
                <RadioWrapper>
                  <input
                    type="radio"
                    id="repeatMonthly"
                    name="repeatSchedule"
                    value='monthly'
                    checked={repeatSchedule === 'monthly'}
                    onChange={(e) => setRepeatSchedule(e.target.value)}
                  />
                  <label htmlFor='repeatMonthly' className="radioMark"></label>
                </RadioWrapper>
                Щомісячно
              </RadioInputGroup>
            </RadioGroup>

            <RadioGroup style={{ display: repeatSchedule === 'daily' ? 'flex' : "none" }}>
              <InputLabel>Періодичність:</InputLabel>
              <RadioInputGroup>
                <RadioWrapper>
                  <input
                    type="radio"
                    id="everyDay"
                    name="repeatDay"
                    value='1'
                    checked={selectDaily === '1'}
                    onChange={(e) => setSelectDaily(e.target.value)}
                  />
                  <label htmlFor='everyDay' className="radioMark"></label>
                </RadioWrapper>
                Кожного дня
              </RadioInputGroup>
              <RadioInputGroup>
                <RadioWrapper>
                  <input
                    type="radio"
                    id="everyOtherDay"
                    name="repeatDay"
                    value='2'
                    checked={selectDaily === '2'}
                    onChange={(e) => setSelectDaily(e.target.value)}
                  />
                  <label htmlFor='everyOtherDay' className="radioMark"></label>
                </RadioWrapper>
                Через день
              </RadioInputGroup>
            </RadioGroup>

            <RadioGroup style={{ display: repeatSchedule === 'weekly' ? 'flex' : "none" }}>
              <InputLabel>У наступні дні:</InputLabel>
              <DayCheckboxGroup>
                {['Понеділок', "Пʼятниця", 'Вівторок', 'Субота', 'Середа', 'Неділя', 'Четвер'].map((day, index) => (
                  <DayCheckbox key={index}>
                    <CheckBoxWrapper>
                      <input type="checkbox" id={`day-${day}`}
                        value={day}
                        checked={selectedDays.includes(day)}
                        onChange={() => handleDaysChange(day)} />
                      <label htmlFor={`day-${day}`} className="checkmark"></label>
                    </CheckBoxWrapper>
                    <Label1 htmlFor={`day-${day}`}>{day}</Label1>
                  </DayCheckbox>
                ))}
              </DayCheckboxGroup>
            </RadioGroup>

            <RadioGroup style={{ display: repeatSchedule === 'monthly' ? 'flex' : "none" }}>
              <InputLabel>Повторювати кожного:</InputLabel>
              <NumberInputWrapper>
                <NumberInput
                  value={dayOfMonth}
                  onChange={handleDayOfMonthChange}
                />
                числа місяця
              </NumberInputWrapper>
            </RadioGroup>
          </RepeatSchedule>

          <DatePickerGroup className="mregular" >
            <DateRadioGroup id="startDate1">
              <InputLabel1 htmlFor="startDate">Почати з:
                <DatePicker
                  id="startDate"
                  selected={startDate} // startDate вже є Date об'єктом
                  minDate={new Date()} // Використовуємо стандартний JavaScript Date об'єкт для minDate
                  dayClassName={dayClassName}
                  onChange={(date) => {
                    setStartDate(date); // setStartDate вже буде Date об'єктом
                    setStopDate(date); // Можна також оновити stopDate, якщо потрібно
                  }}
                  onCalendarOpen={() => setIsCalendarOpen(true)}
                  onCalendarClose={() => setIsCalendarOpen(false)}
                  dateFormat="dd.MM.yyyy"
                  locale={uk}
                  calendarStartDay={1}
                  customInput={
                    <label>
                      <CustomInput
                        className={isCalendarOpen ? "open-calendar" : ""}
                        type="text"
                        name="birthDay"
                        value={format(startDate, 'dd.MM.yyyy')}
                        onChange={() => { console.log('start :>> '); }}
                      />
                    </label>
                  }
                />
              </InputLabel1>
              {isLoading1 ? <ImageAnimation2 /> : calculatedStart && <TextCreation><IconWarn />Перший кошик створиться {calculatedStart} </TextCreation>}
            </DateRadioGroup>
            <DateRadioGroup>
              <RadioInputGroup id="stopDate1">
                <RadioWrapper>
                  <input
                    type="radio"
                    id="stopDate"
                    name="stopCondition"
                    value='date'
                    checked={stopCondition === 'date'}
                    onChange={(e) => setStopCondition(e.target.value)}
                  />
                  <label htmlFor='stopDate' className="radioMark"></label>
                </RadioWrapper>
                Припинити

                <DatePicker
                  id="stopDate"
                  selected={stopDate ? stopDate : null} // stopDate вже є Date об'єктом
                  minDate={startDate ? startDate : new Date()} // Використовуємо JavaScript Date об'єкт для minDate
                  dayClassName={dayClassName1}
                  onChange={(date) => setStopDate(date)} // setStopDate вже буде Date об'єктом
                  dateFormat="dd.MM.yyyy"
                  onCalendarOpen={() => setIsCalendar2Open(true)}
                  onCalendarClose={() => setIsCalendar2Open(false)}
                  locale={uk}
                  customInput={
                    <label>
                      <CustomInput
                        type="text"
                        className={isCalendar2Open ? "open-calendar" : ""}
                        value={stopDate ? format(stopDate, 'dd.MM.yyyy') : ''}
                        onChange={() => { console.log('stop :>> '); }}
                        min={startDate ? format(startDate, 'dd.MM.yyyy') : ''} // Перетворюємо дату в строку
                      />
                    </label>
                  }
                />
              </RadioInputGroup>
              <RadioInputGroup>
                <RadioWrapper>
                  <input
                    type="radio"
                    id="stopAfter"
                    name="stopCondition"
                    value='after'
                    checked={stopCondition === 'after'}
                    onChange={(e) => setStopCondition(e.target.value)}
                  />
                  <label htmlFor="stopAfter" className="radioMark"></label>
                </RadioWrapper>
                Припинити через

                <NumberInputWrapper>
                  <NumberInput
                    value={stopAfter}
                    onChange={handleNumberChange}
                  />
                  разів
                </NumberInputWrapper>
              </RadioInputGroup>
              <RadioInputGroup style={{ height: "48px" }}>
                <RadioWrapper>
                  <input
                    type="radio"
                    id="stopNever"
                    name="stopCondition"
                    value='never'
                    checked={stopCondition === 'never'}
                    onChange={(e) => setStopCondition(e.target.value)}
                  />
                  <label htmlFor="stopNever" className="radioMark"></label>
                </RadioWrapper>
                Не припиняти
              </RadioInputGroup>
            </DateRadioGroup>
          </DatePickerGroup>
        </ExpandableSection>
      )}
    </>
  );
};

export default RepeatUpdate;
